import { render, staticRenderFns } from "./LandingHeaderB.vue?vue&type=template&id=07fd9a51&scoped=true&"
import script from "./LandingHeaderB.vue?vue&type=script&lang=ts&"
export * from "./LandingHeaderB.vue?vue&type=script&lang=ts&"
import style0 from "./LandingHeaderB.vue?vue&type=style&index=0&id=07fd9a51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd9a51",
  null
  
)

export default component.exports